
function DeployMore(rtcConfigUrl) {
    this.rtcconfig = undefined;
    this.rtcConfigUrl = rtcConfigUrl;
    this.get_rtcconfig()
}

DeployMore.prototype = {
    
    get_rtcconfig() {

        let option = {
            url:'https://rs.easemob.com/easemob/rtcconfig.json',
            async:false
        }
        if(this.rtcConfigUrl) {
            option.url = this.rtcConfigUrl;
        }
        let _this = this;

        let rtcconfig = undefined;

        try {
            $.ajax({
                ...option,
                success: data => {
                    console.log('get_rtcconfig success');
                    
                    if(
                        data &&
                        Object.keys(data).length > 0
                    ) {
                        _this.rtcconfig = data;
                        rtcconfig = data
                    }
                },

                error: error => {
                    console.error('DeployMore get error', error);
                    return error
                }
            })
        } catch (error) {
            return
        }
        
        
        return rtcconfig;
    },

    replace_ws(url){
        if(
            this.rtcconfig && 
            this.rtcconfig.ws
        ) {
            let new_url = 'wss://' + this.rtcconfig.ws + '/';
            let RegExp = /wss.*com\//;

            return url.replace(RegExp,new_url);
        }

        return url
    },

    _get_info_from_candifate (candidate) { //在candidate 中获取 ip port
        if(!candidate){
            return {}
        }

        let info = {};
        candidate = candidate.split(' ');
        info.ip = candidate[4]
        info.port = candidate[5]

        // candidate.replace(/(candidate:\d+\s+\d+\s+UDP\s+\d+\s+)([\d\.]+)\s+(\d+)(\s+.*)/g, 
        //                 function (all, $pre, $ip, $port, $after) {
        //                     // console.log(all);
        //                     // console.log(pre, ip, port, after);
        //                     // return $pre + ip + " " + port + $after;
        //                     info.ip = $ip;
        //                     info.port = $port;
        //                 }
        // );

        return info
    },
    // 判断是否可替换 
    // dst_obj: rtcconfig 中的每一candidate 项，
    // ip：待替换candidate ip
    // port：待替换candidate port
    _can_replace(dst_obj, ip, port) {
        if(
            !dst_obj ||
            !ip ||
            !port
        ) {
            return false
        }

        if(
            !dst_obj.src.ip
        ) {
            return false
        }

        if(
            dst_obj.src.ip != ip
        ) {
            return false
        }

        if(
            dst_obj.src.min_port > port ||
            dst_obj.src.max_port < port
        ) {
            return false
        }
        
        return true

    },
    _replace_candidate(candidate) {

        /*
            * "candidate_map": [
            *   {
            *       "dst": {
            *           "ip": "10.66.204.222",
            *           "min_port": "32355",
            *           "max_port": "65535"
            *       },
            *       "src": {
            *           "ip": "39.107.157.65",
            *           "min_port": "32355",
            *           "max_port": "65535"
            *       }
            *   },
            * ]
            * 
            * candidate:3 1 UDP 2013266431 116.62.36.187 31574 typ host
            * 匹配到 src 就会 替换成映射的 dst
        */
        let ip_and_port = this._get_info_from_candifate(candidate);
        let {ip, port} = ip_and_port;

        let _this = this;
        this.rtcconfig.rtc.candidate_map.map(item => {
            // 在 map 中查找 相同的ip 和 范围区间内的 port; 两者必须同时满足
            // 将 src 映射到 dst

            if(_this._can_replace(item, ip, port)){
                let new_ip = item.dst.ip;

                // 替换 port
                let port_difference_value = Number(port) - Number(item.src.min_port); // 即将被替换的 candidate 的port 在最大和最小的port的范围
                let new_port = Number(item.dst.min_port) + Number(port_difference_value);

                let cands_arr = candidate.split(' ');
                cands_arr[4] = new_ip;
                cands_arr[5] = new_port;

                candidate = cands_arr.join(' ');
                // candidate = candidate.replace(/(candidate:\d+\s+\d+\s+UDP\s+\d+\s+)([\d\.]+)\s+(\d+)(\s+.*)/g, 
                // function (all, $pre, $ip, $port, $after) {
                //     // console.log(all);
                //     // console.log(pre, ip, port, after);
                //     return ($pre + new_ip + " " + new_port + $after);
                // });
            }
            
        })

        return candidate
    },

    replace_candidates(candidates) {

        if(!this.rtcconfig) {
            return candidates
        }

        let _this = this;
        
        // 循环 candidates 数组 去替换
        candidates = candidates.map(item => {
            
            if(
                item && 
                item.candidate
            ) {
                item.candidate = _this._replace_candidate(item.candidate);
                return item
            }

            return item
        })



        return candidates
    },

    // 1v1 替换 turn 地址
    replace_trun_url: function replace_trun_url(rtcCfg) {

        // 解析替换
        if (this.rtcconfig && this.rtcconfig.turn) {

            let { iceServers } = rtcCfg;
            if(!iceServers) {
              return rtcCfg
            }

            if(iceServers instanceof Array == false) {
              return rtcCfg
            }

            let new_turn = this.rtcconfig.turn
            iceServers = iceServers.map(item => {
                if(item.url) {
                    item.url = 'turn:' + new_turn
                }
            })
            return rtcCfg;
        }

        return rtcCfg; //如果没有不替换
    }
}
export default DeployMore;